import { createContext, useContext } from 'react';

import {
  useLatestRecordingEntry,
  type useStopAndName,
} from '@/app-shell/rpa/recorder/hooks/recordingNameSession';

type OverlayRecordingName = ReturnType<typeof useStopAndName>;

export const OverlayRecordingNameContext = createContext<OverlayRecordingName | null>(
  null
);

export function useOverlayRecordingName(): OverlayRecordingName {
  const value = useContext(OverlayRecordingNameContext);
  if (!value) {
    throw new Error('useOverlayRecordingName requires OverlayRecordingSession');
  }
  return value;
}

export function useOverlayRecordingSession() {
  const naming = useOverlayRecordingName();
  const latestEntry = useLatestRecordingEntry();
  return { latestEntry, ...naming };
}
